// Shared helpers for the expense pages.

export const PAYMENT_MODES = [
  { value: "CASH", label: "Cash", short: "Cash", icon: "fas fa-money-bill-wave" },
  { value: "UPI", label: "UPI", short: "UPI", icon: "fas fa-mobile-alt" },
  { value: "BANK_TRANSFER", label: "Bank transfer", short: "Bank", icon: "fas fa-university" },
  { value: "CHEQUE", label: "Cheque", short: "Cheque", icon: "fas fa-money-check" },
  { value: "OTHER", label: "Other", short: "Other", icon: "fas fa-ellipsis-h" },
];

export function paymentModeOf(value) {
  return PAYMENT_MODES.find((mode) => mode.value === value) || { value: value || "", label: value ? String(value).replace(/_/g, " ") : "Not set", short: "—", icon: "far fa-question-circle" };
}

// Stable colour per category id, from a palette that reads on white.
const PALETTE = ["#f97316", "#3b82f6", "#10b981", "#8b5cf6", "#ef4444", "#eab308", "#06b6d4", "#ec4899", "#84cc16", "#64748b"];

export function categoryColor(id) {
  const text = String(id || "");
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) hash = (hash * 31 + text.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}

export function isoDate(date) {
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
